'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeOutRight = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)('100%', 0, 0)
  }
};
exports.default = fadeOutRight;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-out-right.js
// module id = 2129
// module chunks = 0